export const getQueryDefaults = () => ({
  retry: (failureCount, error) => {
    const { status } = error?.response ?? {}
    if (status >= 400 && status < 500) {
      return false
    }

    return failureCount < 3
  },
  keepPreviousData: true,
  staleTime: 5 * 60 * 1000, // 5 mins sounds fair?
})

export default getQueryDefaults
